export const testAttributes = {
    BYLINE_MAIN_CONTAINER: 'byline_main_container',
};

export const configuration = {
    prefixAuthor: 'Written By ',
    prefixReviewer: 'Reviewed By '
}